<div class="app-content">
  <div class="intro-text">
      <p>{{'indoor_elite_table_intro' | transloco}}</p>
      <div class="rulebook-app indoor-rules">
        <div style="display: flex; justify-content: space-between;" class="{{interpretation_expanded === false ? 'interpretation--closed' : 'interpretation--open' }} points-allocation"  (click)="interpretation_expanded=!interpretation_expanded">{{'indoor_points' | transloco}}<span class="plus-minus {{interpretation_expanded ? 'plus-minus--less' : 'plus-minus--more'}}"></span></div>
        <div class="interpretation--interpretation_expanded" *ngIf="interpretation_expanded===true">
          <table class="table-points">
            <thead>
              <tr>
                <th class="position">{{'Position' | transloco}}</th>
                <th class="indoor1000"></th>
                <th class="indoor500"></th>
                <th class="indoor250"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="position">{{'1st' | transloco}}</td>
                <td>1000 {{'points' | transloco}}</td>
                <td>500 {{'points' | transloco}}</td>
                <td>250 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'2nd' | transloco}}</td>
                <td>600 {{'points' | transloco}}</td>
                <td>300 {{'points' | transloco}}</td>
                <td>150 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'3rd' | transloco}}</td>
                <td>500 {{'points' | transloco}}</td>
                <td>250 {{'points' | transloco}}</td>
                <td>125 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'4th' | transloco}}</td>
                <td>300 {{'points' | transloco}}</td>
                <td>150 {{'points' | transloco}}</td>
                <td>75 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'5th' | transloco}}</td>
                <td>250 {{'points' | transloco}}</td>
                <td>125 {{'points' | transloco}}</td>
                <td>60 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'6th' | transloco}}</td>
                <td>200 {{'points' | transloco}}</td>
                <td>100 {{'points' | transloco}}</td>
                <td>50 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'7th' | transloco}}</td>
                <td>190 {{'points' | transloco}}</td>
                <td>95 {{'points' | transloco}}</td>
                <td>45 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'8th' | transloco}}</td>
                <td>180 {{'points' | transloco}}</td>
                <td>90 {{'points' | transloco}}</td>
                <td>30 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'9th-16th' | transloco}}</td>
                <td>90 {{'points' | transloco}}</td>
                <td>45 {{'points' | transloco}}</td>
                <td>20 {{'points' | transloco}}</td>
              </tr>
              <tr>
                <td class="position">{{'17th-32nd' | transloco}}</td>
                <td>45 {{'points' | transloco}}</td>
                <td>20 {{'points' | transloco}}</td>
                <td></td>
              </tr>
              <tr>
                <td class="position">{{'33rd-64th' | transloco}}</td>
                <td>20 {{'points' | transloco}}</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
  <div class="content-wrapper">
    <app-filters-elite-ranking></app-filters-elite-ranking>
    <app-elite-ranking-list class="app-elite-ranking-list app-ranking"></app-elite-ranking-list>
  </div>
</div>
